/* HIG-149: instant cart-drawer delivery line.
 * The delivery line used to appear only after warehouse-cart-reconcile.js wrote the
 * Verfügbarkeit property via a server round-trip (~1–2 s lag + layout shift). The same vb
 * data is already in the drawer DOM the moment it renders, so we render the line instantly
 * from it (via the shared window.HPDeliveryText formatter — identical text + logic to the
 * property that is still written for checkout). Read-only on the cart: never adds/changes
 * lines, so it cannot break the cart — worst case the line stays empty (today's behaviour). */
(function () {
  if (window.__hpCartDeliveryInstalled) return;
  window.__hpCartDeliveryInstalled = true;

  var processing = false;

  // Lieferzeit-Redesign 2026-07 (LIEFERZEIT_KONZEPT.md): Der Haken trägt die
  // icon_color seiner STUFE (grün nur sofort, schwarz Tage, grau Wochen), der
  // Text die Standardfarbe — grüner TEXT nur bei «sofort». Die Stufe wird aus
  // dem Property-Text erkannt (Katalog-Abgleich über alle Sprachen), weil die
  // Property nur Text transportiert.
  function tierMetaFor(rest) {
    var core = window.HPDeliveryCore;
    var cat = core && core.LABEL_CATALOG;
    if (!cat) return null;
    var r = String(rest).toLowerCase();
    // WICHTIG (Bugfix 2026-07-30): Die LÄNGSTE Katalog-Übereinstimmung gewinnt.
    // Die instant-Labels («ready to ship», «prêt à expédier», …) sind PRÄFIXE
    // aller langsameren Labels derselben Sprache — ein First-Match hielt darum
    // z.B. «ready to ship in 7 to 9 days» für instant und färbte die Zeile grün
    // (Tobias-Befund im EN-Cart). Längster Treffer = präzisester Treffer.
    var bestKey = null, bestLen = 0;
    var keys = Object.keys(cat.de);
    for (var k = 0; k < keys.length; k++) {
      var key = keys[k];
      for (var l = 0; l < 4; l++) {
        var loc = ['de', 'en', 'fr', 'it'][l];
        var m = cat[loc] && cat[loc][key];
        if (!m) continue;
        var lab = String(m.label_lower).toLowerCase();
        if (lab.length > bestLen && r.indexOf(lab) !== -1) {
          bestLen = lab.length;
          bestKey = key;
        }
      }
    }
    return bestKey ? core.lookupLabel(bestKey) : null;
  }
  function lineColors(rest) {
    var meta = tierMetaFor(rest);
    if (!meta) return { ic: '#222222', tx: '#404040' };
    var instant = meta.priority === 10;
    return { ic: meta.icon_color || '#222222', tx: instant ? (meta.color || '#4EA72E') : '#404040' };
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  // Auch SSR-gerenderte Zeilen (cart-items.liquid) nachfärben — der Server kennt
  // die Stufe nicht (Property = reiner Text) und rendert neutral. Gibt false
  // zurück, solange der Katalog (HPDeliveryCore) noch nicht geladen ist — dann
  // wird der Container NICHT als erledigt markiert und der nächste run()-Pass
  // (DOMContentLoaded/Events) färbt nach. (Bugfix 2026-07-30: dieses Script kann
  // vor hp-delivery-core.js laufen; vorher blieben SSR-Zeilen dauerhaft neutral,
  // «sofort versandfertig» war nach einem Reload nie grün.)
  function colorizeExisting(container) {
    if (!window.HPDeliveryCore || !window.HPDeliveryCore.LABEL_CATALOG) return false;
    container.querySelectorAll('dd').forEach(function (dd) {
      var icEl = dd.querySelector('.hp-cdl-ic') || dd.querySelector('span:first-child');
      var txEl = dd.querySelector('.hp-cdl-tx') || dd.querySelector('span:last-child');
      if (!icEl || !txEl || icEl === txEl) return;
      var c = lineColors(txEl.textContent || '');
      icEl.style.color = c.ic;
      dd.style.color = c.tx;
    });
    return true;
  }

  // SSR-Zeilen zum Property-Text rekonstruieren («✓ 1 Stück …, ✓ 2 Stück …»),
  // um ihn gegen die aktuelle Menge zu validieren (HPDeliveryTextValid).
  function ssrText(container) {
    return [].map.call(container.querySelectorAll('dd'), function (dd) {
      var ic = dd.querySelector('.hp-cdl-ic, span:first-child');
      var tx = dd.querySelector('.hp-cdl-tx, span:last-child');
      return ((ic ? ic.textContent : '') + ' ' + (tx ? tx.textContent : '')).trim();
    }).join(', ');
  }

  // AKTUELLE Menge der Position: Der Drawer patcht beim Mengen-Klick nur das
  // Eingabefeld — Container samt data-qty und alter Property bleiben stehen
  // (Bugfix 2026-07-30, Red-Team-Fund). Darum die Menge live aus dem
  // quantity-input derselben Position lesen; data-qty ist nur Fallback.
  function currentQty(container) {
    // Streng auf die EIGENE Position begrenzen: nur bis zur Zeilen-Ebene (tr/li)
    // hochlaufen und abbrechen, sobald ein Element mehrere Positionen enthält —
    // sonst griffe der Walk das Mengenfeld des PDP-Produktformulars ab.
    var el = container;
    for (var i = 0; i < 6 && el; i++) {
      if (el.querySelectorAll && el.querySelectorAll('[data-hp-cart-delivery]').length > 1) break;
      var inp = el.querySelector && el.querySelector('quantity-input input');
      if (inp && inp.value) return inp.value;
      if (el.tagName === 'TR' || el.tagName === 'LI') break;
      el = el.parentElement;
    }
    return container.getAttribute('data-qty');
  }

  function renderFromVb(container, qty) {
    var text = window.HPDeliveryText
      ? window.HPDeliveryText(container.getAttribute('data-vid'), qty)
      : null;
    if (!text) { container.style.minHeight = '0'; return; } // no delivery data → collapse, no gap
    var parts = text.split(', ');
    var html = '';
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].trim();
      if (!p) continue;
      var icon = p.charAt(0);
      var rest = p.slice(1).trim();
      var c = lineColors(rest);
      html += '<dd class="m-0" style="display:flex;color:' + c.tx +
        ';font-weight:500;"><span class="hp-cdl-ic" style="display:inline-block;flex:0 0 1.3em;width:1.3em;color:' + c.ic + ';">' +
        esc(icon) + '</span><span class="hp-cdl-tx">' + esc(rest) + '</span></dd>';
    }
    container.innerHTML = html;
  }

  function fill(container) {
    if (!window.HPDeliveryCore || !window.HPDeliveryCore.LABEL_CATALOG) return; // Katalog noch nicht da → nächster Pass
    var qty = currentQty(container);
    var hasContent = container.children.length || container.textContent.trim();
    if (hasContent) {
      // Inhalt (SSR oder frühere Client-Renderung) gegen die AKTUELLE Menge
      // validieren; passt er nicht mehr → frisch aus dem vb rendern.
      var stale = window.HPDeliveryTextValid
        ? !window.HPDeliveryTextValid(container.getAttribute('data-vid'), qty, ssrText(container))
        : false;
      if (!stale) {
        if (container.getAttribute('data-hp-filled') !== '1' && colorizeExisting(container)) {
          container.setAttribute('data-hp-filled', '1');
        }
        return;
      }
      renderFromVb(container, qty);
      container.setAttribute('data-hp-filled', '1');
      return;
    }
    renderFromVb(container, qty);
    container.setAttribute('data-hp-filled', '1');
  }

  // Cart-Kopfzeile (Lieferzeit-Redesign 2026-07, Entscheid Tobias): Zustellfenster
  // des LANGSAMSTEN Artikels im Korb. Alles sofort → datiert wie bisher («morgen»/
  // Datum, 17-Uhr-Cutoff via etaWindowText('instant')); langsamster Artikel eine
  // Stufe → deren Datumsfenster; made_to_order → «Lieferung in ca. X bis Y
  // Monaten». Versteckt, wenn keine Zeile Lieferdaten hat.
  // (Ersetzt den alten ✓-Erstzeichen-Check, der seit dem Haken-Redesign 06/2026
  // JEDEN Korb für «alles sofort» hielt und fälschlich «morgen» zeigte.)
  function updateCartEta() {
    var el = document.querySelector('[data-hp-cart-eta]');
    var out = document.querySelector('[data-hp-cart-eta-text]');
    var core = window.HPDeliveryCore;
    if (!el || !out || !window.HPDeliveryBuckets || !core || !core.etaWindowText) return;
    var nodes = document.querySelectorAll('[data-hp-cart-delivery]');
    var slowest = null, slowestP = -1;
    for (var i = 0; i < nodes.length; i++) {
      var buckets = window.HPDeliveryBuckets(nodes[i].getAttribute('data-vid'), currentQty(nodes[i]));
      if (!buckets || !buckets.length) continue;
      for (var j = 0; j < buckets.length; j++) {
        var pcur = core.priorityOf({ label_key: buckets[j].key });
        if (pcur > slowestP && pcur !== 999) { slowestP = pcur; slowest = buckets[j]; }
      }
    }
    if (!slowest) { if (!el.hidden) el.hidden = true; return; }
    var next = core.etaWindowText(slowest.key, slowest.months_min, slowest.months_max);
    if (!next) { if (!el.hidden) el.hidden = true; return; }
    // CRITICAL: only write when the value actually changed. Writing textContent
    // every run is a childList mutation that the cart-drawer MutationObserver
    // picks up → run() again → write again → infinite loop (froze the browser).
    if (out.textContent !== next) out.textContent = next;
    if (el.hidden) el.hidden = false;
  }

  function run() {
    if (processing) return;
    processing = true;
    try {
      var nodes = document.querySelectorAll('[data-hp-cart-delivery]');
      for (var i = 0; i < nodes.length; i++) fill(nodes[i]);
      updateCartEta();
    } catch (e) { /* never break the cart */ }
    processing = false;
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  // Bugfix 2026-07-30 (Teil 2, volle Warenkorb-SEITE /cart): Dieses Script läuft
  // als defer VOR hp-delivery-core.js; auf der Cart-Seite gibt es weder
  // Drawer-Mutationen noch Cart-Events, die run() später nochmal anstossen —
  // die SSR-Zeilen blieben dauerhaft neutral. Begrenzter Retry, bis der Katalog
  // geladen ist (global via theme.liquid, kommt also immer).
  (function waitForCore(tries) {
    if (window.HPDeliveryCore && window.HPDeliveryCore.LABEL_CATALOG) { run(); return; }
    if (tries <= 0) return;
    setTimeout(function () { waitForCore(tries - 1); }, 120);
  })(50);

  ['cart:updated', 'cart:refresh', 'cart:item-added', 'cart:change', 'on:line-item:change'].forEach(function (evt) {
    document.addEventListener(evt, run);
    window.addEventListener(evt, run);
  });

  // The cart drawer re-renders by replacing innerHTML (Section Rendering). Running
  // inside the MutationObserver callback fills the line before paint → no empty flash.
  // Scoped to the cart drawer only (was document.body) so it never reacts to unrelated
  // DOM churn elsewhere on the page (e.g. the product recommendations re-rendering) —
  // perf + avoids any side effects. The cart page relies on the cart events above.
  try {
    var scope = document.querySelector('cart-drawer') || document.getElementById('cart-drawer');
    if (scope) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { run(); return; }
        }
      });
      mo.observe(scope, { childList: true, subtree: true });
    }
  } catch (e) {}
})();
